import PlayIcon from '@/presentation/assets//svg/PlayIcon.svg'
import MaximizeButton from '@/presentation/components/Carousel/components/MaximizeButton'

interface VideoItemProps {
  filePath: string
  onMaximizeButtonClick: () => void
}

const VideoItem: React.FC<VideoItemProps> = ({
  filePath,
  onMaximizeButtonClick
}) => (
  <div className="relative cursor-pointer px-2">
    <MaximizeButton onClick={onMaximizeButtonClick} />

    <video
      className="h-[260px] w-full rounded-2xl bg-black blur-[1px] md:h-[460px]"
      src={filePath}
      onClick={() => null}
      controls={false}
      muted
    />

    <img className="absolute inset-0 m-auto size-10" src={PlayIcon} />
  </div>
)

export default VideoItem
